import React from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css'

function InspectorControlDate(props) {
    return <Calendar onChange={props.onChange} value={props.value} />;
}

export { InspectorControlDate }
